import { render, staticRenderFns } from "./EntradaSalidaManual.vue?vue&type=template&id=36cbf981&scoped=true&"
import script from "./EntradaSalidaManual.vue?vue&type=script&lang=ts&"
export * from "./EntradaSalidaManual.vue?vue&type=script&lang=ts&"
import style0 from "./EntradaSalidaManual.vue?vue&type=style&index=0&id=36cbf981&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cbf981",
  null
  
)

export default component.exports